import axios from "../axios";
import { parseContentDispositionFilename } from "../../utils/http";

const api = {
  initialiseSupplierDecarbonization(id, accessToken) {
    const config = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.post(`/supplier/${id}/decarbonization`, {}, config).then(({ data }) => data);
  },

  getSupplierDecarbonization(id, accessToken) {
    const config = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/supplier/${id}/decarbonization`, config).then(({ data }) => data);
  },

  getSupplierChartData(id, accessToken) {
    const config = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/supplier/${id}/decarbonization/chart`, config).then(({ data }) => data);
  },

  getSupplierReducedChartData(id, accessToken) {
    const config = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/supplier/${id}/decarbonization/chart/reduced`, config).then(({ data }) => data);
  },

  updateSupplierEstimatedGrowth({ id, newData }, accessToken) {
    const headers = {
      headers: {
        "Authorization": `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      }
    };
    return axios.patch(`/supplier/${id}/decarbonization/estimated-yearly-emissions-growth`,
      newData, headers).then(({ data }) => data);
  },

  exportSupplierDecarbonizationData({ id, year }, accessToken) {
    const config = {
      responseType: "arraybuffer",
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/supplier/${id}/decarbonization/export?year=${year}`, config)
      .then(({ data, headers }) => {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        const defaultFileName = parseContentDispositionFilename(
          headers["content-disposition"], "Supplier Decarbonization Export - " + year);
        link.href = url;
        link.setAttribute("download", defaultFileName);
        document.body.appendChild(link);
        link.click();
        return true;
      });
  }
};

export default api;